export default __webpack_public_path__ + "static/media/java02.eac993f8.PNG";